import { useState, useEffect } from "react";
import api from "../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquareCaretLeft } from "@fortawesome/free-solid-svg-icons";


const Edit = ({ IdNivelRiesgo, getNivelesRiesgo }) => {
  const [expandido, setExpandido] = useState(false);
  const [Nombre, setNombre] = useState('');
  const [Descripcion, setDescripcion] = useState("");

  const updateNivelRiesgo = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`/nivelesRiesgo/updateNivelRiesgo/${IdNivelRiesgo}`, {
        Nombre,
        Descripcion
      })
        .then(() => {
          getNivelesRiesgo();
          setNombre('');
          setDescripcion('');
          setExpandido(false);
        })
        .catch((error) => {
          console.log()
          console.log("error: ", error);
        });
    } catch (error) {
      console.log(" Ha ocurrido un error en updateNivelRiesgo");
      console.error(error);
    }
  }
  //as

  const handleClick = () => {
    setExpandido(!expandido);
  };

  return (
    <div>
      {expandido ? (
        <div className={`button-bar ${expandido ? 'box' : 'is-hidden'}`}>
          <div className="button-bar-subContent">
            <form onSubmit={e => updateNivelRiesgo(e)}>
              <FontAwesomeIcon icon={faSquareCaretLeft} size="2xl" style={{ color: "#3488CE", cursor: "pointer" }} onClick={handleClick} />

              <div className={`field`} style={{ backgroundColor: `${Nombre.length > 0 ? "lightgreen" : ''}` }}>
                <div className="container">
                  <label className="label">Nombre:</label>
                  <div className="control">
                    <input
                      type="name"
                      className="input"
                      value={Nombre}
                      onChange={(e) => setNombre(e.target.value)}
                      placeholder="Nombre"
                    />
                  </div>
                </div>
              </div>
              <div className={`field`} style={{ backgroundColor: `${Descripcion.length > 0 ? "lightgreen" : ''}` }}>
                <div className="container">
                  <label className="label">Descripción:</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      value={Descripcion}
                      onChange={(e) => setDescripcion(e.target.value)}
                      placeholder="Descripcion"
                    />
                  </div>
                </div>
              </div>
              <div className="field">
                <button type="submit" style={{ border: "none", backgroundColor: "white" }}><FontAwesomeIcon icon={faSquareCheck} size="2xl" style={{ color: "#00ff11", }} /></button>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className="has-text-centered">
          <button className="button is-small is-info mr-2 icon-pencil" title="Editar" onClick={handleClick}><FontAwesomeIcon icon={faPencil} /></button>
        </div>
      )}
    </div >
  );
}

const AddNivelesRiesgo = () => {
  const [NivelesRiesgo, setNivelesRiesgo] = useState([]);
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});

  useEffect(() => {
    getNivelesRiesgo();
  }, []);

  const createNivelRiesgo = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/createNivelRiesgo`, {
        Nombre,
        Descripcion,
      });
      getNivelesRiesgo();

    } catch (error) {
      console.log(error);
    }
  };

  const getNivelesRiesgo = async () => {
    const response = await api.get(`/getNivelesRiesgo`);
    setNivelesRiesgo(response.data);
  };

  const cambiarEstado = async (IdNivelRiesgo) => {
    try {
      await api.patch(`/nivelesRiesgo/cambiarEstadoNivelRiesgo/${IdNivelRiesgo}`);
      getNivelesRiesgo();
    } catch (error) {
      console.log(error);
    }
  };

  const columnas = [
    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true
    },
    {
      name: 'Descripción',
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({ ...mostrarDescripcion, [row.IdNivelRiesgo]: !mostrarDescripcion[row.IdNivelRiesgo] });
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > 40;

        const estiloCelda = {
          display: 'flex',
          alignItems: 'center',
          width: '400vw',
          maxHeight: mostrarDescripcion[row.IdNivelRiesgo] ? 'none' : '40vh',
          overflow: mostrarDescripcion[row.IdNivelRiesgo] ? 'visible' : 'hidden',
        };

        const estiloContenido = {
          flex: 1,
          maxHeight: '45vh',
          textOverflow: mostrarDescripcion[row.IdNivelRiesgo] ? 'clip' : 'ellipsis',
          whiteSpace: mostrarDescripcion[row.IdNivelRiesgo] ? 'normal' : 'nowrap',
        };

        return (
          <div style={estiloCelda}>
            <div style={estiloContenido}>
              {!mostrarDescripcion[row.IdNivelRiesgo] ? (descripcion.length > 70 ? descripcion.substring(0, 70) + '...' : descripcion) : descripcion}
            </div>
            {mostrarBoton && (
              <button className="btn" onClick={(e) => {
                toggleDescripcion();
                e.preventDefault();
              }}>
                {mostrarDescripcion[row.IdNivelRiesgo] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: '40vw',
    },
    {
      cell: (row) => (
        <Edit IdNivelRiesgo={row.IdNivelRiesgo} getNivelesRiesgo={getNivelesRiesgo} />
      ),
      maxHeight: '6px',
    },
    {
      name: "Activo",
      cell: (NivelRiesgo) =>
        NivelRiesgo.estado === 1 ?
          <FontAwesomeIcon icon={faSquarePlus} style={{ color: "#37ff00", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(NivelRiesgo.IdNivelRiesgo)} />
          :
          <FontAwesomeIcon icon={faSquareMinus} style={{ color: "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(NivelRiesgo.IdNivelRiesgo)} />,
      ignoreRowClick: true,
      AllowOverflow: true,
      button: true,
      compact: true
    }
  ]

  //=============================================================================
  // html content
  //=============================================================================
  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Ingresa el Nivel de Riesgo</strong>
        </div>
        <form onSubmit={(event) => { createNivelRiesgo(event); }}>
          <div className="field">
            <label className="label required">Nombre Nivel de Riesgo</label>
            <div className="control">
              <input
                type="name"
                className="input"
                value={Nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre"
                required
              />
            </div>

            <label className="label">Descripcion Nivel de Riesgo</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                placeholder="Descripcion"

              />
            </div>
          </div>

          <div className="field">
            <div>
              <button type="submit" className="button is-success">Guardar</button>
            </div>
          </div>
        </form>
        <br />

        <div style={{ width: 'auto', left: '20vw', position: 'absolute', border: '1px solid gray', borderRadius: '8px' }}>
          <DataTable
            pagination
            columns={columnas}
            data={NivelesRiesgo}
            dense={false}
          />
        </div>
      </div>
    </div>
  );
};

export default AddNivelesRiesgo;

